module.exports = __webpack_public_path__ + "static/main-photo-9aab6d6d6043c8b5e7dfb53cc18e7d1a.jpg";